var _rect, _path, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHrv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.1304,
    height: 23.4783,
    rx: 1.17391,
    fill: "currentColor",
    opacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9609 8.3735H15.5134C15.4525 8.36859 15.3907 8.36859 15.3297 8.3735H15.1809C15.1352 8.38897 15.0914 8.40631 15.0497 8.42538C15.001 8.44445 14.9542 8.46524 14.9097 8.48763C14.8805 8.50884 14.8541 8.53139 14.8309 8.55507C14.7908 8.58775 14.7557 8.62247 14.7259 8.65883L13.3172 11.8563L9.67719 5.08446C9.61588 4.98431 9.50405 4.89778 9.35689 4.83663C9.20973 4.77548 9.03439 4.74268 8.85469 4.74268C8.67499 4.74268 8.49964 4.77548 8.35249 4.83663C8.20533 4.89778 8.0935 4.98431 8.03219 5.08446L6.70489 8.42538L3.21094 8.3735C2.97887 8.3735 2.75631 8.42816 2.59222 8.52545C2.42812 8.62274 2.33594 8.75469 2.33594 8.89228C2.33594 9.02986 2.42812 9.16182 2.59222 9.25911C2.75631 9.3564 2.97887 9.41105 3.21094 9.41105H6.97344C7.02317 9.39686 7.07012 9.37946 7.11344 9.35918C7.16216 9.3401 7.20891 9.31931 7.25344 9.29692L7.33219 9.22948C7.37389 9.19744 7.40913 9.16262 7.43719 9.12573L8.85469 5.92828L12.4947 12.7001C12.556 12.8002 12.6678 12.8868 12.815 12.9479C12.9621 13.0091 13.1375 13.0419 13.3172 13.0419C13.4969 13.0419 13.6722 13.0091 13.8194 12.9479C13.9665 12.8868 14.0784 12.8002 14.1397 12.7001L15.5134 9.29692H18.9609C19.193 9.29692 19.4077 9.25911 19.5797 9.25911C19.7437 9.16182 19.8359 9.02986 19.8359 8.89228C19.8359 8.75469 19.7437 8.62274 19.5797 8.52545C19.4156 8.42816 19.193 8.3735 18.9609 8.3735Z",
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.17578,
    y: 15.2607,
    width: 18.7826,
    height: 0.586957,
    rx: 0.293478,
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrv);
export default __webpack_public_path__ + "static/media/HRV.27d4426ae9b0607a3ec36add76cf3e1c.svg";
export { ForwardRef as ReactComponent };